"use client";

import React, { useState } from "react";
import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import { Menu, X, LogOut } from "lucide-react";
import { useSidebar } from "@/features/core/hooks/useSidebar";
import { useAuthStore } from "../stores";

export const NavigationBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { sidebar, validateRol } = useSidebar();
  const router = useRouter();
  const pathname = usePathname();
  const logout = useAuthStore((state) => state.logout);

  const handleLogout = () => {
    logout();
    router.push("/auth/login");
  };

  return (
    <>
      {/* --- Compact bottom bar (hamburger) --- */}
      <div className="fixed bottom-5 right-5 z-50">
        <button
          onClick={() => setIsOpen(true)}
          className="bg-[#E30613] text-white p-3 rounded-full shadow-lg hover:bg-[#c30510] transition-all"
        >
          <Menu size={24} />
        </button>
      </div>

      {/* --- Fullscreen Navigation Overlay --- */}
      <div
        className={`fixed inset-0 bg-[#F5F7F6] z-50 flex flex-col items-center justify-start pt-10 pb-20 transition-all duration-500 ease-in-out transform ${
          isOpen
            ? "translate-y-0 opacity-100"
            : "translate-y-full opacity-0 pointer-events-none"
        }`}
      >
        {/* Header with Close Button */}
        <div className="flex justify-between items-center w-full px-6 mb-8">
          <h2 className="text-2xl font-bold text-[#E30613]">Menú Principal</h2>
          <button
            onClick={() => setIsOpen(false)}
            className="p-2 rounded-full hover:bg-[#E30613]/10 transition"
          >
            <X size={28} className="text-[#E30613]" />
          </button>
        </div>

        {/* Navigation Items */}
        <nav className="flex flex-col gap-5 w-full px-10 mt-4">
          {sidebar.map(
            (item) =>
              validateRol(item) && (
                <Link
                  key={item.key}
                  href={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`flex items-center justify-between p-4 rounded-xl shadow-sm bg-white hover:bg-[#E30613]/10 border border-gray-100 transition-all ${
                    pathname === item.path ? "text-[#E30613]" : "text-[#5A4A49]"
                  }`}
                >
                  <div className="flex items-center gap-4">
                    <span className="text-[#E30613] text-xl">
                      {item.icon}
                    </span>
                    <span className="text-lg font-medium">{item.label}</span>
                  </div>
                  {pathname === item.path && (
                    <div className="w-3 h-3 bg-[#E30613] rounded-full" />
                  )}
                </Link>
              )
          )}
        </nav>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="mt-auto mb-8 bg-[#E30613] hover:bg-[#c30510] text-white font-semibold px-6 py-3 rounded-lg flex items-center gap-2 shadow-md transition-all"
        >
          <LogOut size={20} />
          Cerrar sesión
        </button>
      </div>
    </>
  );
};
